import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LineItemModels, LineItemMappers, LineItemSlotsProvider, LineItemCard, DeliveryEstimation } from '@grandvisionhq/lib-visuals';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '../../../context/Cart/context.js';
import '@grandvisionhq/common';
import '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import '@grandvisionhq/frk-routing';
import { useRemoveInsuranceFromCart } from '../../../hooks/use-remove-insurance-from-cart.js';
import { useCartSlots } from '../../../slots/context.js';
import '../../../slots/footer-slot/context.js';
import '../../../slots/header-slot/context.js';
import '../../../slots/sidebar-slot/context.js';
import { Insurance } from '../components/Insurance.js';
import { QuantitySelector } from '../components/QuantitySelector.js';
import 'classnames';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/shipping';
import { DeliveryIndicatorContainer } from '../containers/DeliveryIndicatorContainer.js';
import { PriceTooltipContainer } from '../containers/PriceTooltipContainer.js';

const VisualLineItemsContainer = ({ lineItems , isReadOnly  })=>{
    const intl = useIntl();
    const { isLineItemDeliveryEstimationDisabled , isPrescriptionGlassesQuantitySelectorDisabled =false , isPrescriptionGlassesDuplicateButtonDisabled =true , isDynamicLineItemDeliveryEstimationEnabled =false ,  } = useFeatureToggles();
    const { Slots  } = useCartSlots();
    const [removeFromCart] = useRemoveInsuranceFromCart();
    const [isProtectionModalOpen, setIsProtectionModalOpen] = React.useState(false);
    const handleProtectionInfoToggle = React.useCallback(()=>{
        setIsProtectionModalOpen(!isProtectionModalOpen);
    }, [
        isProtectionModalOpen
    ]);
    const labels = React.useMemo(()=>({
            quantity: intl.getLabel('cart.item.quantity'),
            iconLeftEye: intl.getLabel('products.contactLenses.leftEye'),
            iconRightEye: intl.getLabel('products.contactLenses.rightEye'),
            power: intl.getLabel('products.contactLenses.prescription.power'),
            deliveredEvery: intl.getLabel('cart.delivery.frequency'),
            perBox: intl.getLabel('products.perBox'),
            configuration: intl.getLabel('account.order.detail.configuration'),
            prescription: intl.getLabel('account.order.detail.prescription'),
            subscriptionDetails: intl.getLabel('cart.item.subscription.title'),
            addOn: intl.getLabel('products.addOn.title'),
            removeInsurance: intl.getLabel('products.insurance.remove'),
            delivery: intl.getLabel('products.deliveryEstimation.label'),
            deliveryTooltip: intl.getLabel('cart.lineItem.deliveryEstimation.tooltip', {
                hideLabelKey: true
            }),
            disclaimer: intl.getLabel('cart.lineItem.glasses.disclaimer', {
                hideLabelKey: true
            }),
            disclaimerTooltip: intl.getLabel('cart.lineItem.glasses.disclaimerTooltip', {
                hideLabelKey: true
            })
        })
    , [
        intl
    ]);
    const removeInsurance = (insurance)=>{
        if (!insurance) {
            return;
        }
        removeFromCart(insurance.id);
    };
    const handleRemoval = (lineItem)=>removeInsurance(lineItem.insurance)
    ;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, Slots.ProtectionInfoModal && /*#__PURE__*/ React.createElement(Slots.ProtectionInfoModal, {
        isOpen: isProtectionModalOpen,
        onClose: handleProtectionInfoToggle
    }), lineItems.map((lineItem, i)=>{
        var ref3;
        const showInsurance = !lineItem.insurance && lineItem.eligibleInsurance && lineItem.eligibleInsurance.sku && !isReadOnly;
        const accordionSection = [];
        if ('prescription' in lineItem) {
            if (LineItemModels.isGlassesBundleLineItem(lineItem)) {
                accordionSection.push({
                    type: 'GLASSES_BUNDLE',
                    title: labels.prescription,
                    prescription: lineItem.prescription
                });
            } else if (lineItem.prescription) {
                accordionSection.push({
                    type: 'CONTACT_LENSES',
                    title: labels.prescription,
                    prescription: lineItem.prescription
                });
            }
        }
        if (lineItem.isSubscription && ((ref3 = lineItem.subscriptionDetails) === null || ref3 === void 0 ? void 0 : ref3.deliveryInterval)) {
            accordionSection.push({
                type: 'SUBSCRIPTION',
                title: labels.subscriptionDetails,
                expanded: true,
                deliveryInterval: lineItem.subscriptionDetails.deliveryInterval
            });
        }
        if ('bundleChildLineItems' in lineItem && lineItem.bundleChildLineItems) {
            var ref1;
            const bundleChildLineItems = LineItemMappers.getEnrichedBundleChildLineItems({
                lineItem,
                addOnLabel: labels.addOn,
                isReadOnly,
                actionLabel: labels.removeInsurance,
                actionCallback: handleRemoval
            });
            accordionSection.push(swcHelpers.objectSpread({
                type: 'GENERIC_BUNDLE',
                title: labels.configuration,
                bundleChildLineItems,
                expanded: Boolean((ref1 = lineItem.insurance) === null || ref1 === void 0 ? void 0 : ref1.sku)
            }, labels.disclaimer && {
                disclaimer: labels.disclaimer
            }, labels.disclaimerTooltip && {
                disclaimerTooltip: labels.disclaimerTooltip
            }));
        }
        var _price;
        const baseProps = {
            accordionSection,
            currency: intl.currency,
            originalPrice: lineItem.originalPrice,
            discount: lineItem.discountPrice,
            relativeDiscount: lineItem.relativeDiscount,
            imagePath: lineItem.imageUrl,
            lineItemId: lineItem.lineItemId,
            price: (_price = lineItem.price) !== null && _price !== void 0 ? _price : 0,
            quantity: lineItem.quantity,
            subtitle: lineItem.subtitle,
            title: lineItem.title,
            isCompactCard: false,
            hasDiscountSection: true,
            quoteConfig: lineItem === null || lineItem === void 0 ? void 0 : lineItem.quoteConfig,
            additionalInfo: lineItem.additionalInfo,
            isContainerBasedLayout: true
        };
        const showQuantity = ()=>{
            return !(lineItem.type === 'GLASSES_BUNDLE' && isPrescriptionGlassesQuantitySelectorDisabled);
        };
        const LineItemCardSlot = {
            QuantitySelector: !isReadOnly ? ()=>/*#__PURE__*/ React.createElement(QuantitySelector, {
                    shouldShowQuantity: showQuantity(),
                    shouldShowDuplicateButton: lineItem.type === 'GLASSES_BUNDLE' && !isPrescriptionGlassesDuplicateButtonDisabled,
                    lineItemId: lineItem.lineItemId,
                    isReadOnly: isReadOnly
                })
             : undefined,
            StockAndDelivery: !isLineItemDeliveryEstimationDisabled ? ()=>/*#__PURE__*/ React.createElement(DeliveryIndicatorContainer, {
                    lineItemId: lineItem.lineItemId
                })
             : undefined,
            PriceTooltip: ()=>{
                var ref, ref2;
                return ((ref = lineItem.unitPrice) === null || ref === void 0 ? void 0 : (ref2 = ref.appliedDiscounts) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ React.createElement(PriceTooltipContainer, {
                    id: lineItem.id,
                    appliedDiscounts: lineItem.unitPrice.appliedDiscounts
                }) : null;
            },
            Footer: ()=>showInsurance ? /*#__PURE__*/ React.createElement(Insurance, {
                    visualLineItem: lineItem,
                    handleOpenModal: handleProtectionInfoToggle
                }) : null
            ,
            DeliveryEstimation: isDynamicLineItemDeliveryEstimationEnabled ? ()=>{
                var ref, ref4;
                 return React.createElement(DeliveryEstimation, {
                    tooltipId: `delivery-estimation-tooltip-${lineItem.sku}${i}`,
                    labels: {
                        label: labels.delivery,
                        tooltip: labels.deliveryTooltip
                    },
                    earliestDeliveryDate: (ref = lineItem.deliveryEstimation) === null || ref === void 0 ? void 0 : ref.earliestDeliveryDate,
                    latestDeliveryDate: (ref4 = lineItem.deliveryEstimation) === null || ref4 === void 0 ? void 0 : ref4.latestDeliveryDate
                });
            } : undefined
        };
        return /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
            key: `${lineItem.sku}-${i}`,
            slots: LineItemCardSlot
        }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: `${lineItem.sku}-${i}`,
            imageHref: lineItem.productUrl
        }, baseProps)));
    }));
};

export { VisualLineItemsContainer };
//# sourceMappingURL=VisualLineItemsContainer.js.map
